import { GAP_TOKEN, INPUT_WIDTHS_CONDITION_REFINEMENT, ROW_GAP_TOKEN } from '../../constants/inlineLayout';
import { useConditionInputs } from '../../hooks/useConditionInputs';
import { useConditionRefinement } from '../../hooks/useConditionRefinement';
import { useElementSize } from '../../hooks/useElementSize';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import EditorConditionRefinement from './EditorConditionRefinement';
import EditorConditionValueInput from './EditorConditionValueInput';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import UISelect from 'UIComponents/input/UISelect';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import TruncateString from 'UIComponents/text/UITruncateString';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import UpdateFilterWithExternalOptionsNotification from '../operator/UpdateFilterWithExternalOptionsNotification';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorConditionRefinementResponsive = ({
  condition,
  emptyRefinementCondition,
  filterFamily,
  inputUse,
  onConditionChange
}) => {
  const {
    width
  } = useElementSize();
  const {
    disableRefinement,
    isChecked,
    isRefinementEnabled,
    onCheckboxChange,
    onRefinementConditionOperatorChange,
    onRefinementConditionValueChange,
    refinementCondition,
    refinementLabel,
    tooltipText
  } = useConditionRefinement(condition, emptyRefinementCondition, filterFamily, onConditionChange);
  const {
    canFilterBeConverted,
    disableOperatorSelection,
    disableValueInput,
    handleUpdateClick,
    isOperatorIncompatible,
    onSelectedOptionChange,
    operatorOptions
  } = useConditionInputs({
    condition: refinementCondition,
    filterFamily,
    isRefinement: true,
    isRefinementEnabled,
    onConditionOperatorChange: onRefinementConditionOperatorChange,
    onConditionValueChange: onRefinementConditionValueChange
  });
  if (width.size === 'sm') {
    return /*#__PURE__*/_jsx(EditorConditionRefinement, {
      condition: condition,
      emptyRefinementCondition: emptyRefinementCondition,
      filterFamily: filterFamily,
      onConditionChange: onConditionChange,
      inputUse: inputUse
    });
  }
  return /*#__PURE__*/_jsxs(ConditionBox, {
    isRefinement: true,
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexWrap: 'nowrap',
      columnGap: GAP_TOKEN,
      rowGap: ROW_GAP_TOKEN,
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          flexShrink: 0,
          width: `${INPUT_WIDTHS_CONDITION_REFINEMENT[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(Tooltip, {
          title: tooltipText,
          disabled: !disableRefinement,
          children: /*#__PURE__*/_jsx(Checkbox, {
            checked: isChecked,
            disabled: disableRefinement,
            onChange: onCheckboxChange,
            children: /*#__PURE__*/_jsx(TruncateString, {
              tooltip: !disableRefinement,
              children: refinementLabel
            })
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          flexShrink: 0,
          width: `${INPUT_WIDTHS_CONDITION_REFINEMENT[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(UISelect, {
          "data-onboarding": "filter-condition-select-field",
          "data-selenium-test": "fr-filter-operator-select",
          "data-test-id": "fr-filter-operator-select",
          disabled: disableOperatorSelection,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          readOnly: operatorOptions.length === 1,
          value: refinementCondition.constructor.toString(),
          buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          minWidth: `${INPUT_WIDTHS_CONDITION_REFINEMENT[width.size]}px`
        },
        children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
          condition: refinementCondition,
          disabled: disableValueInput,
          filterFamily: filterFamily,
          inputUse: inputUse,
          onChange: onRefinementConditionValueChange,
          size: "md"
        })
      })]
    }), isOperatorIncompatible && /*#__PURE__*/_jsx(UpdateFilterWithExternalOptionsNotification, {
      onUpdateClick: handleUpdateClick,
      canFilterBeConverted: canFilterBeConverted
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: refinementCondition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: refinementCondition
    })]
  });
};
export default EditorConditionRefinementResponsive;